module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_7_4.11af6e61.jpeg";